exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#footer{position:relative;text-indent:34px;height:40px;line-height:40px;font-size:12px;color:#c0ccda;background-color:#324057}.copy-right{float:right;margin-right:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-7e145295!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/Bottom.vue
// module id = 593
// module chunks = 0